import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

window.customElements.define('e-slider', class extends HTMLElement {
  constructor() {
    super();
    this.classList.add('swiper');
    this.defaults = {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 15,
      direction: 'horizontal',
      navigation: {
        nextEl: this.querySelector('.swiper-button-prev'),
        prevEl: this.querySelector('.swiper-button-next'),
      },
      breakpoints: {
        576: {
          slidesPerView: 2.1,
        },
        1200: {
          slidesPerView: 3.1,
        },
        1680: {
          slidesPerView: 4.1,
        },
      },
    };
    this.options = this.getAttribute('options');
    try {
      this.options = JSON.parse(this.options);
    } catch (e) {
      console.warn('E-slider: Options have the wrong format', e);
      this.options = {};
    }
    this.settings = { ...this.defaults, ...this.options };
    this.swiper = new Swiper(this, this.settings);
    if (this.classList.contains('click-move')) this.addEventListener('click', (e) => e.target.closest('.swiper-slide') && this.swiper.slideTo(this.swiper.clickedIndex));
  }
});
